import {
  InvoiceRow,
  InvoiceStatus,
  PayoutSettings,
  PreferredPayoutSpeed
} from "@wingspanhq/wingspan-api-sdk";
import {
  IMember,
  UserAccountType
} from "@wingspanhq/users/dist/lib/interfaces";
import { selectorIsDomesticMember } from "../../../../shared/selectors/selectorIsDomesticMember";

/**
 * Whether the payee may request an instant payout for a paid-but-not-yet-
 * deposited invoice. On v3 the "paid, awaiting deposit" gate reads the row's
 * raw `status === Paid` plus `!events.depositedAt` (both on the search row).
 *
 * Accepted regression (V3_MIGRATION_TRACKER.md): the v1 per-invoice
 * `amountDetails` presence check and the invoice-level `member.payoutPreferences
 * !== Instant` check are dropped — neither is on the v3 row. The payout-speed
 * preference is still enforced via the account's `PayoutSettings`.
 */
export const selectorIsInstantPayoutAllowed = (
  invoice: InvoiceRow,
  payoutSettings?: PayoutSettings,
  member?: IMember
) =>
  !!payoutSettings &&
  !!member &&
  invoice.status === InvoiceStatus.PAID &&
  !invoice.events?.depositedAt &&
  payoutSettings.preferredPayoutSpeed !== PreferredPayoutSpeed.INSTANT &&
  selectorIsDomesticMember(member) &&
  member.user.settings?.userAccountType !== UserAccountType.enterprise;
